export interface RateSource {
  name: string;
  description: string;
  id: string;
  createdAt: string;
  updatedAt: string;
}

export enum TariffClientType {
  INDIVIDUAL = 'INDIVIDUAL',
  CORPORATE = 'CORPORATE',
}
